import { useMutation, useQueryClient } from "react-query";
import editAttributesHandler from "./handlers/editAttributesHandler";
import editAttributesStore from "../../../helpers/Attribute/editAttributesStore";
import editAttributesResponder from "./responders/editAttributesResponder";

const usePatchAttributes = () => {
  const queryClient = useQueryClient();
  const editMutation = useMutation(
    editAttributesHandler,
    editAttributesResponder(queryClient)
  );

  /**
   * Edit Attribute
   *
   * @param {Props} editedItems: Array of attributes to update
   * @param {boolean} newRequest optional defaults to true, if false is sent an api request will not be attempted
   */
  const editAttributes = async (props, newRequest = true) => {
    if (!props?.args?.editedItems) {
      return console.error(
        "editAttributes | props.args.editedItems is required: populate with the original version of the item you are updating"
      );
    }

    if (!props?.args) {
      return console.error(
        "editAttributes | props.args.editedItems is required: populate with the original version of the item you are updating"
      );
    }

    if (newRequest === false) {
      return editAttributesStore({
        queryClient,
        editedItems: props.args.editedItems,
      });
    }

    const response = await editMutation.mutateAsync(props);
    return response;
  };

  const {
    isLoading: editAttributesLoading,
    isError: hasEditAttributesError,
    error: editAttributesError,
    isSuccess: editAttributesSuccess,
  } = editMutation;

  return {
    editAttributes,
    editAttributesLoading,
    hasEditAttributesError,
    editAttributesError,
    editAttributesSuccess,
  };
};

export default usePatchAttributes;
